import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  Breakpoints,
  IpoLanguageService,
  IpoMatchMediaService,
} from '@ip-only/front-end-library';
import { Observable, Subject } from 'rxjs';
import { ContractorUserData, UserData } from '../../../user/user';
import { UserService } from '../../../user/user.service';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss'],
  standalone: false,
})
export class TopMenuComponent implements OnInit, OnDestroy {
  portalUser$: Observable<UserData | null>;
  contractorUser$: Observable<ContractorUserData | null>;

  showResourceFinder = true;
  isUserFederated = false;

  menuExpanded = false;
  breakpoints$: Observable<Breakpoints>;

  private cancelSub$ = new Subject<void>();

  constructor(
    private matchMediaService: IpoMatchMediaService,
    private userService: UserService,
    private router: Router,
    private languageService: IpoLanguageService,
  ) {}

  ngOnInit() {
    this.breakpoints$ = this.matchMediaService.getBreakpoints$();
    this.portalUser$ = this.userService.getPortalUser$();
    this.portalUser$.subscribe((user) => {
      if (user) {
        this.isUserFederated = Boolean(user.federatedUser);
      }
    });
  }

  ngOnDestroy() {
    this.cancelSub$.next();
  }

  async logout() {
    await this.userService.logout();
  }

  redirectToContact() {
    this.router.navigate(['/home']);
  }

  onExpandedChanged(expanded: boolean) {
    this.menuExpanded = expanded;
  }

  get isMobileScreen() {
    return window.matchMedia(`(max-width: 768px)`).matches;
  }
}
